import React from 'react';

const C = {
  bg:           '#0B1928',
  bgCard:       '#132030',
  border:       'rgba(255,255,255,0.09)',
  orange:       '#FF6B00',
  textPrimary:  '#F0F4F8',
  textSecondary:'#8496A8',
  textMuted:    '#5A7A9A',
};
const font = `'Inter',-apple-system,BlinkMacSystemFont,'Segoe UI',sans-serif`;

function Privacy() {
  return (
    <div style={{ maxWidth:'680px', margin:'0 auto', minHeight:'100vh', backgroundColor:C.bg, fontFamily:font, padding:'40px 24px 80px' }}>

      {/* Header */}
      <div style={{ marginBottom:'40px' }}>
        <div style={{ fontSize:'13px', fontWeight:'700', color:C.orange, letterSpacing:'5px', marginBottom:'16px' }}>BRACKETZ</div>
        <h1 style={{ fontSize:'28px', fontWeight:'700', color:C.textPrimary, margin:'0 0 8px' }}>Privacy Policy</h1>
        <div style={{ fontSize:'13px', color:C.textMuted }}>Last updated: April 11, 2026</div>
      </div>

      {/* Sections */}
      {[
        {
          title: 'Overview',
          content: `Bracketz ("we," "us," or "our") is committed to protecting your privacy. This Privacy Policy explains how we collect, use, and safeguard your information when you use our daily bracket challenge app and website at playbracketz.com.`
        },
        {
          title: 'Information We Collect',
          content: `We collect the following types of information:\n\n• Email address — used to create and manage your account\n• Username — your display name within the app\n• Bracket picks and submission history — your daily bracket selections\n• Device identifiers — used for push notifications\n• Purchase history — if you subscribe to Bracketz Pro\n• In-app messages — comments and friend communications within the app`
        },
        {
          title: 'How We Use Your Information',
          content: `We use your information to:\n\n• Provide and operate the Bracketz app and service\n• Send daily bracket reminders and streak notifications\n• Process Bracketz Pro subscription payments\n• Show community pick statistics and leaderboards\n• Respond to your support requests\n• Improve app performance and fix bugs\n• Generate anonymized, aggregated insights about app usage and bracket engagement`
        },
        {
          title: 'Data Sharing',
          content: `We do not sell your personal information (such as your name, email address, or individual account data) to third parties.\n\nWe share data only with the following service providers who help us operate the app:\n\n• Firebase (Google) — backend database and authentication\n• Stripe — payment processing for Bracketz Pro subscriptions\n• Mailgun — transactional email delivery\n\nAll third-party providers are bound by their own privacy policies and applicable data protection laws.`
        },
        {
          title: 'Aggregated and Anonymized Data',
          content: `We may collect, analyze, and share aggregated and anonymized data about how users interact with Bracketz — such as bracket pick trends, category engagement patterns, feature usage statistics, and general demographic engagement data.\n\nThis aggregated data does not identify you personally and cannot be used to contact you. We may share or license this anonymized data with business partners, research organizations, advertisers, or potential acquirers as part of our business operations.\n\nExamples of aggregated data we may share:\n\n• "65% of users picked Michael Jordan over LeBron James"\n• "Sports brackets have the highest daily engagement"\n• "Average user streak is 12 days"\n\nThis type of data sharing is standard practice in the app industry and does not compromise your personal privacy.`
        },
        {
          title: 'Data Security',
          content: `All data transmitted between your device and our servers is encrypted in transit using HTTPS/TLS. We use Firebase's security rules to protect your data at rest.`
        },
        {
          title: 'Data Retention',
          content: `We retain your account data for as long as your account is active. If you delete your account, we will delete your personal information within 30 days, except where retention is required by law.`
        },
        {
          title: 'Your Rights',
          content: `You have the right to:\n\n• Access the personal data we hold about you\n• Request correction of inaccurate data\n• Request deletion of your account and associated data\n• Opt out of marketing communications\n\nTo exercise these rights, visit playbracketz.com/delete-account or contact us at privacy@playbracketz.com.`
        },
        {
          title: 'Children\'s Privacy',
          content: `Bracketz is intended for users 18 years of age and older. We do not knowingly collect personal information from anyone under 18. If we become aware that a minor has provided us with personal information, we will delete it immediately.`
        },
        {
          title: 'Push Notifications',
          content: `We may send push notifications to remind you to play your daily bracket and alert you about streak milestones. You can disable notifications at any time through your device settings.`
        },
        {
          title: 'Changes to This Policy',
          content: `We may update this Privacy Policy from time to time. We will notify you of significant changes by posting the new policy on this page with an updated date.`
        },
        {
          title: 'Contact Us',
          content: `If you have questions about this Privacy Policy, contact us at:\n\nprivacy@playbracketz.com\nplaybracketz.com`
        },
      ].map((section, i) => (
        <div key={i} style={{ marginBottom:'32px' }}>
          <h2 style={{ fontSize:'16px', fontWeight:'700', color:C.orange, marginBottom:'10px', margin:'0 0 10px' }}>{section.title}</h2>
          <div style={{ fontSize:'14px', color:C.textSecondary, lineHeight:'1.8', whiteSpace:'pre-line' }}>{section.content}</div>
        </div>
      ))}

    </div>
  );
}

export default Privacy;
